import { render, staticRenderFns } from "./PlasticAttributes.vue?vue&type=template&id=762f4f4c&scoped=true"
import script from "./PlasticAttributes.vue?vue&type=script&lang=js"
export * from "./PlasticAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762f4f4c",
  null
  
)

export default component.exports